import type { CaretCsvRowIssue } from './types';

const ISSUES_META_COLUMNS = ['Row', 'Error'] as const;

export const buildCsvIssuesFile = (delimiter: string, dataHeader: string, issues: CaretCsvRowIssue[]): string => {
    const header = [...ISSUES_META_COLUMNS, ...dataHeader.split(delimiter)].join(delimiter);
    const rows = issues.map(
        ({ rowNumber, error, rawLine }) => `${rowNumber}${delimiter}${error}${delimiter}${rawLine}`,
    );
    return `${[header, ...rows].join('\n')}\n`;
};

export const buildFatalCsvIssueFile = (
    delimiter: string,
    dataHeader: string,
    rowNumber: number,
    error: string,
): string => buildCsvIssuesFile(delimiter, dataHeader, [{ rowNumber, error, rawLine: '' }]);
